const m365Config = {
  clientID: process.env.REACT_APP_M365_CLIENT_ID,
};

export default m365Config;
